// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"193":"c35961a2","738":"123b94c2","767":"8d73b632","800":"152e268a","972":"662e2e82"}[chunkId] + ".css";
};